import { faList } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { useOptionalSession } from 'src/contexts/SessionContext';

import { usePermissionCheck } from '../usePermissionCheck';

import { EditNavigationDialog } from './EditNavigationDialog';


export const EditNavButton = () => {
  const { t: tCommon } = useTranslation('translation', { keyPrefix: 'common' });
  const { user } = useOptionalSession();
  const { canManageAll } = usePermissionCheck();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!user || !canManageAll) {
    return null;
  }

  return (
    <>
      <Button
        onClick={() => setDialogOpen(true)}
        size="small"
        color="primary"
        fullWidth
        sx={{ justifyContent: 'center' }}
        startIcon={
          <Icon icon={faList} size="small" />
        }
      >
        {tCommon('buttons.editNavigation')}
      </Button>
      <EditNavigationDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
